import { render, staticRenderFns } from "./QuestionForm1.vue?vue&type=template&id=29b77a5d&scoped=true&"
import script from "./QuestionForm1.vue?vue&type=script&lang=js&"
export * from "./QuestionForm1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b77a5d",
  null
  
)

export default component.exports